/**
 * @file Standard entity list component.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { TranslateService } from '@ngx-translate/core';
import { ListBase } from '../../base/list/list.base';
import { DialogService } from '../../core/dialog.service';
import { AlertsService } from '../../core/alerts.service';
import { OverlayService } from '../../core/overlay.service';
import { LocalStorageService } from '../../core/local-storage.service';
import { DomainService } from '../../domain.service';
import { EventsService } from '../../core/event.service';
import { UserService } from '../../user.service';
import { Router } from '@angular/router';
import { ActionService } from '../../core/action.service';
/**
 * The standard entity list component
 */
var ListComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ListComponent, _super);
    /**
     * Constructs a ListComponent.
     * @param configurationsService Service to get the configuration of this component.
     * @param domainService Service to load and save entity data.
     * @param dialogService Service for displaying dialogs.
     * @param alertsService Service for publish alerts.
     */
    function ListComponent(userService, domainService, dialogService, alertsService, translateService, router, overlayService, localStorageService, eventsService, actionService) {
        return _super.call(this, userService, domainService, dialogService, alertsService, translateService, router, overlayService, localStorageService, eventsService, actionService) || this;
    }
    return ListComponent;
}(ListBase));
export { ListComponent };
